import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=5e975bae&scoped=true&"
import script from "./createOrder.vue?vue&type=script&lang=ts&"
export * from "./createOrder.vue?vue&type=script&lang=ts&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=5e975bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e975bae",
  null
  
)

export default component.exports